import styled from 'styled-components';
import { InfoCircleFilled } from '@ant-design/icons';
import { TextRegular24 } from 'styles/typography';
import { Spin } from 'antd';

export const Spinner = styled(Spin)`
  margin: auto;
`;

export const EmptyStateWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const InfoIcon = styled(InfoCircleFilled)`
  color: ${({ theme }) => theme.blue};
  font-size: 63px;
  margin-bottom: 28px;
`;

export const EmptyStateText = styled(TextRegular24)`
  margin-bottom: 37px;
  color: ${({ theme }) => theme.black};
`;

export const ContentWrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CompanyListWrapper = styled.div`
  background: ${p => p.theme.backgroundColor};
  height: 100%;
  display: flex;
  flex-direction: column;
`;
